import { createContext, type JSX, type ReactNode } from 'react';
import { type serviceContainer } from '../container';

type ServiceContainerProviderProps = {
  container: typeof serviceContainer;
  children: ReactNode;
};

export const ServiceContainerContext = createContext<
  typeof serviceContainer | null
>(null);

export const ServiceContainerProvider = ({
  container,
  children,
}: ServiceContainerProviderProps): JSX.Element => {
  return (
    <ServiceContainerContext.Provider value={container}>
      {children}
    </ServiceContainerContext.Provider>
  );
};

export const ServiceContainerConsumer = ServiceContainerContext.Consumer;
